/* 上部のあ行リスト */
import * as React from 'react';

import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import * as UserListField from '../constants/UserListField';
import { getElementByType, RETURN_FALSE } from '../utils/commonUtil';
import { Global } from '../utils/global';

const KANA_A: string = 'kanaA';
const KANA_KA: string = 'kanaKa';
const KANA_SA: string = 'kanaSa';
const KANA_TA: string = 'kanaTa';
const KANA_NA: string = 'kanaNa';
const KANA_HA: string = 'kanaHa';
const KANA_MA: string = 'kanaMa';
const KANA_YA: string = 'kanaYa';
const KANA_RA: string = 'kanaRa';
const KANA_WA: string = 'kanaWa';
const KANA_ALL: string = 'kanaAll';

class KanaList extends React.Component {
  // 頭文字フィルター用.
  kanaSelected: string = '';

  searchHeadChar(e: React.MouseEvent<HTMLAnchorElement>, kana: string) {
    // 背景変更.
    this.selectKana(kana, (e.target as HTMLElement).parentElement);

    switch (kana) {
      case KANA_A:
        this.kanaSelected = 'あいうえお';
        break;
      case KANA_KA:
        this.kanaSelected = 'かきくけこ';
        break;
      case KANA_SA:
        this.kanaSelected = 'さしすせそ';
        break;
      case KANA_TA:
        this.kanaSelected = 'たちつてと';
        break;
      case KANA_NA:
        this.kanaSelected = 'なにぬねの';
        break;
      case KANA_HA:
        this.kanaSelected = 'はひふへほ';
        break;
      case KANA_MA:
        this.kanaSelected = 'まみむめも';
        break;
      case KANA_YA:
        this.kanaSelected = 'ややゆゆよ';
        break;
      case KANA_RA:
        this.kanaSelected = 'らりるれろ';
        break;
      case KANA_WA:
        this.kanaSelected = 'わわわわん';
        break;
      case KANA_ALL:
      default:
        this.kanaSelected = '';
        break;
    }

    // フィルター処理.
    this.filter();

    // ページ遷移防止.
    e.preventDefault();
    return false;
  }

  // フィルター処理.
  filter() {
    // userのオブジェクトの入ったhiddenのClass.
    let usersObject: HTMLCollectionOf<Element> = document.getElementsByClassName('user');

    // search枠.
    const searchText: HTMLInputElement | undefined = getElementByType('search');
    if (searchText) {
      // search枠のフィルター用文字列.
      const filterWord: string = searchText.value;

      if (filterWord) {
        // フィルターする(HTMLCollectionは配列に一回変換する必要あり).
        usersObject = [].slice.call(usersObject).filter(function(element: HTMLElement) {
          const parent: HTMLElement | null = element.parentElement;
          if (parent) {
            // 一旦全員消す(次の頭文字フィルターに委ねるため).
            parent.hidden = true;
          }

          const html: string = element.innerHTML;
          const row = JSON.parse(html);
          return Object.keys(row).some(function(key: string) {
            return String(row[key]).indexOf(filterWord) > -1;
          });
        });
      }
    }

    // ここから頭文字フィルター.
    let index: number = 0;
    for (const key in usersObject) {
      if (usersObject.hasOwnProperty(key)) {
        // 1つのエレメント.
        const element: Element = usersObject[key];

        // stringfyで入ってるのでいったん変換.
        const kanaInitial: string = (JSON.parse(element.innerHTML) as UserListField.User).user_name_kana;

        // カナ名頭文字.
        const firstKana: string = kanaInitial.substring(0, 1);
        const parent: HTMLElement | null = element.parentElement;
        if (this.kanaSelected === '' || this.kanaSelected.search(firstKana) > -1) {
          if (parent) {
            // 居る人は表示する.
            parent.hidden = false;

            // 偶数は白/奇数グレー(cssがhidden要素をスキップしてくれないので上書き).
            const isEven: boolean = index % 2 === 0;
            [].forEach.call(parent.childNodes, (child: Node) =>
              (child as HTMLElement).style.background = isEven ? '#fff' : '#e8e4df'
            );

            index++;
          }
        } else {
          if (parent) {
            // 該当しない人は消す.
            parent.hidden = true;
          }
        }
      }
    }
  }

  componentDidMount() {
    Global.kanaSerach = () => {
      // フィルター.
      this.filter();
    };
  }

  // user_select.js
  // かなの背景を変更.
  selectKana(id: string, selectedKanaBtn: HTMLElement | null) {
    if (selectedKanaBtn === null) {
      return;
    }

    // 選択したひらがなを表示/非選択表示に変更.
    if (selectedKanaBtn.classList.contains('selected')) {
      // do something.
    } else {
      selectedKanaBtn.classList.add('selected');
    }

    // 選択したひらがな以外を非選択表示に変更.
    const eleList = document.querySelectorAll('ul.kanaList li');
    for (let i = 0; i < eleList.length; ++i) {
      if (eleList[i] !== selectedKanaBtn) {
        eleList[i]
          .classList
          .remove('selected');
      }
    }
  }

  render() {
    return (
      <div className="header">
        <ul className="kanaList">
          <li id={KANA_A}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_A)}
              href={RETURN_FALSE}
            >
              あ
            </a>
          </li>
          <li id={KANA_KA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_KA)}
              href={RETURN_FALSE}
            >
              か
            </a>
          </li>
          <li id={KANA_SA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_SA)}
              href={RETURN_FALSE}
            >
              さ
            </a>
          </li>
          <li id={KANA_TA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_TA)}
              href={RETURN_FALSE}
            >
              た
            </a>
          </li>
          <li id={KANA_NA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_NA)}
              href={RETURN_FALSE}
            >
              な
            </a>
          </li>
          <li id={KANA_HA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_HA)}
              href={RETURN_FALSE}
            >
              は
            </a>
          </li>
          <li id={KANA_MA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_MA)}
              href={RETURN_FALSE}
            >
              ま
            </a>
          </li>
          <li id={KANA_YA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_YA)}
              href={RETURN_FALSE}
            >
              や
            </a>
          </li>
          <li id={KANA_RA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_RA)}
              href={RETURN_FALSE}
            >
              ら
            </a>
          </li>
          <li id={KANA_WA}>
            <a
              onClick={event => this.searchHeadChar(event, KANA_WA)}
              href={RETURN_FALSE}
            >
              わ
            </a>
          </li>
          <li id={KANA_ALL} className="selected">
            <a
              onClick={event => this.searchHeadChar(event, KANA_ALL)}
              href={RETURN_FALSE}
            >
              全て
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default KanaList;



// WEBPACK FOOTER //
// ./src/components/KanaList.tsx